export default __webpack_public_path__ + "static/media/dolphin.64e2187e.png";